import {
  Component,
  QueryList,
  ElementRef,
  ViewChildren,
  Output,
  Input,
  EventEmitter,
  OnInit,
  OnChanges,
  ChangeDetectorRef,
  SimpleChanges,
} from "@angular/core";
import { CoreService } from "../../../../shared/services/core.service";
import { Basket } from "../../../../shared/models/baske.model";
import { BasketItem } from "../../../../shared/models/basketitem.model";
import { ProductPagemodel } from "src/app/shared/pageModels/productPage";
import { NgStyle, NgClass, AsyncPipe, DecimalPipe } from "@angular/common";
import { Product } from "src/app/shared/models/product.model";
import { CurrencyFormatPipe } from "src/app/shared/layout/pipe/status.pipe";
@Component({
  selector: "app-extraproduct",
  templateUrl: "./extraproduct.component.html",
  styleUrls: ["../add-product.component.scss"],
  standalone: true,
  imports: [NgStyle, NgClass, AsyncPipe, DecimalPipe, CurrencyFormatPipe],
})
export class ExtraproductComponent implements OnInit, OnChanges {
  @ViewChildren("checkboxes") checkboxes: QueryList<ElementRef>;
  Merchant$ = this.coreService.Merchant$;
  @Output() closeExtra = new EventEmitter();
  @Input() currentBasket: Basket;
  @Input() currentBasketItems: BasketItem[];
  @Input() tempProductId: number;
  @Input() ProductQtyId: number;
  @Input() pageModel: ProductPagemodel;

  selectedExtras: number[] = [];
  limitValue = 0;

  productData: Product;
  constructor(private coreService: CoreService) {}
  ngOnChanges(changes): void {}
  ngOnInit(): void {
    // TODO document why this method 'ngOnInit' is empty
  }
  //funtion used to Add extra product to the basket
  AddExtraProductToBasket() {
    const extraproducts = [];

    // Get selected checkbox values
    this.checkboxes
      .filter((elem) => elem.nativeElement.checked)
      .forEach((elem) => {
        const obj = this.pageModel.selectedProduct.extra_product.find(
          (x) => x.id == elem.nativeElement.value
        );
        if (obj) extraproducts.push(obj);
      });

    // If none selected, exit
    if (extraproducts.length < 1) {
      return;
    }

    // Fetch limit & enable flag
    const enableExtra =
      this.pageModel?.selectedProduct?.enable_extra_product_selection;
    const limit =
      this.pageModel?.selectedProduct?.extra_product_selection_limit;

    // Determine if restriction applies
    const noLimit = !enableExtra || enableExtra !== 1 || !limit || limit === 0;

    // 🔹 Enforce selection limit before adding
    if (!noLimit && extraproducts.length > limit) {
      this.limitValue = limit;
      this.openLimitReachedModal();
      return; // Prevent basket addition
    }

    // Proceed with normal add flow
    let b: Basket;
    let bi: BasketItem;
    if (this.currentBasket != null) {
      this.currentBasketItems = [...this.currentBasket.items];
    }

    // Assign current object to another variable and link extras with main product
    extraproducts.forEach((elem) => {
      bi = {
        Id: elem.id,
        productcatId: elem.catId,
        qtyId: this.ProductQtyId.toString(),
        productId: this.tempProductId.toString(),
        name: elem.name,
        price: elem.is_discount ? elem.discounted_price : elem.price,
        discountprice: elem.is_discount ? elem.discounted_price : 0,
        is_discount: elem.is_discount,
        Actualprice: elem.price,
        productImage: elem.images[0] ? elem.images[0].url : "",
        stockunlimited: elem.stock_unlimited,
        stock: elem.stock,
        quantity: 1,
        extra_product_limit: elem.extra_product_limit ?? 0,
        selFirstAttrName: "attr1",
        selSecondAttrName: "attr2",
        selFirstAttrValue: "",
        selSecondAttrValue: "",
        selectedVariantid: 0,
        SelectedVariantName: "",
        totalprice: this.coreService.GetTotalprice(elem),
        vat_rate: elem.vat_rate,
        vat_amount: elem.vat_amount,
        is_mixandmatch: elem.is_mixandmatch,
        is_delivery_fee_product: elem.is_delivery_fee_product,
        is_promo_exclude: elem.is_promo_exclude,
        is_extra: true,
      };

      const existingItem = this.currentBasketItems.find((x) => x.Id == elem.id);

      if (existingItem) {
        if (
          !existingItem.qtyId ||
          Number(existingItem.qtyId) === this.ProductQtyId
        ) {
          existingItem.quantity += 1;
        } else {
          this.currentBasketItems.push(bi);
        }
      } else {
        this.currentBasketItems.push(bi);
      }

      const linkedItem = this.currentBasketItems.find(
        (x) => x.qtyId == this.tempProductId.toString()
      );
      if (linkedItem) linkedItem.qtyId = this.ProductQtyId.toString();
    });

    // Basket Totals
    this.pageModel.basketTotal = this.currentBasketItems.reduce(
      (sum, item) => sum + item.price * item.quantity,
      0
    );

    const disbasketTotal = this.currentBasketItems
      .filter((x) => !x.is_promo_exclude)
      .reduce((sum, item) => sum + item.price * item.quantity, 0);

    const avgVat =
      this.currentBasketItems
        .filter((x) => x.price > 0)
        .reduce((sum, item) => sum + item.vat_rate, 0) /
      this.currentBasketItems.filter((x) => x.price > 0).length;

    this.pageModel.basketVATTotal = (this.pageModel.basketTotal * avgVat) / 100;
    this.pageModel.basketTotalLessVAT =
      this.pageModel.basketTotal - this.pageModel.basketVATTotal;

    // Update basket
    b = {
      ...this.currentBasket,
      items: this.currentBasketItems,
      retailerId: CoreService.retailerId,
      discountableTotal: disbasketTotal,
      orderTotal: this.pageModel.basketTotal,
      orderTotalLessVAT: this.pageModel.basketTotalLessVAT,
      VATAmt: this.pageModel.basketVATTotal,
    };

    this.coreService.addItemToBasket(b);
    this.close();
  }

  ngAfterViewInit() {}

  //funtion used to close popup
  close() {
    this.closeExtra.emit();
  }

  onExtraProductSelect(event: Event, id: number) {
    const checkbox = event.target as HTMLInputElement;
    const enableExtra =
      this.pageModel?.selectedProduct?.enable_extra_product_selection;
    const limit =
      this.pageModel?.selectedProduct?.extra_product_selection_limit;

    // If undefined, 0, or not 1 → no restriction
    const noLimit = !enableExtra || enableExtra !== 1 || !limit || limit === 0;

    if (noLimit) {
      if (checkbox.checked) {
        this.selectedExtras.push(id);
      } else {
        this.selectedExtras = this.selectedExtras.filter((x) => x !== id);
      }
      return;
    }

    // Restriction applies
    if (checkbox.checked) {
      if (this.selectedExtras.length < limit) {
        this.selectedExtras.push(id);
      } else {
        // Revert the checkbox and show custom modal
        checkbox.checked = false;
        this.limitValue = limit;
        this.openLimitReachedModal();
      }
    } else {
      this.selectedExtras = this.selectedExtras.filter((x) => x !== id);
    }
  }

  openLimitReachedModal() {
    const modal = document.getElementById("limitReachedModal");
    if (modal) {
      modal.style.display = "block";
      modal.classList.add("show");
    }
  }

  closeLimitReachedModal() {
    const modal = document.getElementById("limitReachedModal");
    if (modal) {
      modal.style.display = "none";
      modal.classList.remove("show");
    }
  }
}
